
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/rentals-network/author/[...slug]",
      function () {
        return require("private-next-pages/rentals-network/author/[...slug].tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/rentals-network/author/[...slug]"])
      });
    }
  